import type { MediaItem } from "@/types/media";

export const mediaList: MediaItem[] = [
  {
    id: "m-001",
    title: "星海归途",
    type: "movie",
    year: 2024,
    region: "中国大陆",
    genres: ["科幻", "冒险", "剧情"],
    rating: 8.7,
    popularity: 98650,
    duration: "132分钟",
    releaseDate: "2024-06-14",
    director: "陈望山",
    status: "已上映",
    tagline: "当最后一艘方舟驶向星海，人类在归途中重新学会仰望。",
    cast: [
      { personId: "p-01", role: "饰 舰长 顾行舟" },
      { personId: "p-02", role: "饰 工程师 白昼" },
      { personId: "p-03", role: "饰 领航员 程遇" },
      { personId: "p-04", role: "饰 首席科学家 苏黎" },
    ],
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20sci-fi%20movie%20poster%20key%20art%2C%20lone%20astronaut%20silhouette%20facing%20a%20vast%20glowing%20nebula%20and%20a%20distant%20ark%20starship%2C%20deep%20blue%20and%20warm%20amber%20rim%20light%2C%20dramatic%20volumetric%20lighting%2C%20film%20grain%2C%20elegant%20minimal%20composition%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=poster-m001&orientation=portrait",
    synopsis:
      "当地球资源即将耗尽，人类建造了最后一艘方舟，驶向遥远的宜居星系。舰长顾行舟带领一支临时拼凑的船队踏上漫长航程，却在途中接收到一段来历不明的求救信号。为了追查真相，他不得不重新审视自己坚持多年的使命与信念。影片以宏大的太空景观与细腻的人物情感，讲述了一个关于选择、牺牲与归乡的故事。",
  },
  {
    id: "m-002",
    title: "暗夜追凶",
    type: "movie",
    year: 2023,
    region: "中国香港",
    genres: ["犯罪", "悬疑", "惊悚"],
    rating: 8.3,
    popularity: 87420,
    duration: "118分钟",
    releaseDate: "2023-11-03",
    director: "邓绍元",
    status: "已上映",
    tagline: "每个雨夜，城市都在替凶手保守秘密。",
    cast: [
      { personId: "p-06", role: "饰 刑警 秦朗" },
      { personId: "p-09", role: "饰 法医 顾清晏" },
      { personId: "p-08", role: "饰 线人 阿海" },
    ],
    poster:
      "https://readdy.ai/api/search-image?query=Neo-noir%20crime%20thriller%20movie%20poster%2C%20rain-soaked%20neon%20city%20street%20at%20night%2C%20a%20detective%20in%20coat%20seen%20from%20behind%2C%20reflections%20on%20wet%20asphalt%2C%20teal%20and%20orange%20lighting%2C%20cinematic%20anamorphic%20composition%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=poster-m002&orientation=portrait",
    synopsis:
      "一连串发生在雨夜的凶案让整座城市陷入恐慌，刑警秦朗与法医顾清晏在层层线索中逐渐逼近真相。随着调查深入，他们发现所有受害者都与一桩尘封多年的旧案有关。真相比想象中更加残酷，而追凶的代价，也许正是他们最不愿面对的过往。",
  },
  {
    id: "m-003",
    title: "山那边的风",
    type: "movie",
    year: 2024,
    region: "中国大陆",
    genres: ["剧情", "家庭"],
    rating: 8.9,
    popularity: 76210,
    duration: "126分钟",
    releaseDate: "2024-04-19",
    director: "何远洲",
    status: "已上映",
    tagline: "有些话，走了很远的路才说得出口。",
    cast: [
      { personId: "p-07", role: "饰 母亲 何秀兰" },
      { personId: "p-10", role: "饰 父亲 陈建国" },
      { personId: "p-02", role: "饰 女儿 陈小满" },
    ],
    poster:
      "https://readdy.ai/api/search-image?query=Warm%20poetic%20family%20drama%20movie%20poster%2C%20terraced%20mountain%20village%20at%20golden%20sunset%2C%20a%20lone%20figure%20walking%20an%20earthen%20path%2C%20soft%20haze%2C%20emerald%20green%20and%20amber%20tones%2C%20elegant%20minimal%20composition%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=poster-m003&orientation=portrait",
    synopsis:
      "为了照顾年迈的父母，在城市打拼多年的女儿回到了阔别已久的山村。两代人之间，横亘着城市的疏离与乡土的牵绊，也藏着许多未曾说出口的心事。在四季流转与日常琐碎中，一家人慢慢学会重新理解彼此。这是一部安静而有力量的家庭故事。",
  },
  {
    id: "m-004",
    title: "时间的褶皱",
    type: "movie",
    year: 2023,
    region: "中国大陆",
    genres: ["爱情", "奇幻", "剧情"],
    rating: 7.8,
    popularity: 65180,
    duration: "109分钟",
    releaseDate: "2023-08-25",
    director: "温故",
    status: "已上映",
    tagline: "如果时间可以折叠，你会在哪一页等我。",
    cast: [
      { personId: "p-01", role: "饰 摄影师 江迟" },
      { personId: "p-05", role: "饰 调音师 林晚" },
    ],
    poster:
      "https://readdy.ai/api/search-image?query=Dreamy%20romantic%20fantasy%20movie%20poster%2C%20two%20figures%20in%20an%20endless%20surreal%20corridor%20of%20folding%20light%2C%20melting%20clocks%20and%20soft%20bokeh%2C%20rose%20gold%20and%20lavender%20dusk%20tones%2C%20artistic%20ethereal%20composition%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=poster-m004&orientation=portrait",
    synopsis:
      "摄影师江迟在一次意外的胶片冲印中，发现自己的照片里出现了尚未发生的事。他循着线索遇见了调音师林晚，两人在交错的时空中反复相遇，又反复错过。为了留住彼此，他们必须找到时间的褶皱，并且勇敢地面对其中藏着的告别。",
  },
  {
    id: "m-005",
    title: "最后一张胶片",
    type: "movie",
    year: 2022,
    region: "法国",
    genres: ["剧情", "文艺"],
    rating: 8.1,
    popularity: 43260,
    duration: "114分钟",
    releaseDate: "2022-12-09",
    director: "安托万·勒克莱尔",
    status: "已上映",
    tagline: "光影会消失，但记忆不会。",
    cast: [
      { personId: "p-04", role: "饰 放映员 老莫" },
      { personId: "p-11", role: "饰 学徒 阿宇" },
    ],
    poster:
      "https://readdy.ai/api/search-image?query=Artistic%20nostalgic%20drama%20movie%20poster%2C%20vintage%20film%20projector%20beam%20cutting%20through%20dust%20in%20a%20dim%20old%20cinema%2C%20warm%20sepia%20and%20amber%20tones%2C%20soft%20grain%2C%20elegant%20melancholic%20composition%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=poster-m005&orientation=portrait",
    synopsis:
      "老放映员在影院即将拆迁前，收到了最后一盒未冲洗的胶片。他带着年轻的学徒阿宇，踏上寻找胶片主人的旅程。一路上，光影与回忆交织，两代人关于电影的热爱与不舍也被一点点唤醒。",
  },
  {
    id: "m-006",
    title: "极地救援",
    type: "movie",
    year: 2024,
    region: "美国",
    genres: ["动作", "冒险", "灾难"],
    rating: 7.6,
    popularity: 92130,
    duration: "128分钟",
    releaseDate: "2024-07-05",
    director: "马克·道森",
    status: "已上映",
    tagline: "在世界尽头，没有人能独自生还。",
    cast: [
      { personId: "p-08", role: "饰 队长 凯恩" },
      { personId: "p-12", role: "饰 医生 艾拉" },
    ],
    poster:
      "https://readdy.ai/api/search-image?query=Epic%20arctic%20survival%20action%20movie%20poster%2C%20helicopter%20over%20a%20vast%20cracked%20glacier%20during%20a%20blizzard%2C%20tiny%20figures%20against%20immense%20ice%20cliffs%2C%20cold%20steel%20blue%20and%20white%20with%20orange%20flares%2C%20cinematic%20scale%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=poster-m006&orientation=portrait",
    synopsis:
      "一场突如其来的极地风暴，让正在南极科考站执行任务的队伍与外界彻底失联。队长凯恩带领仅存的队员穿越冰裂缝与暴风雪，去寻找唯一的撤离点。在极端环境中，勇气、信任与人性受到了最严苛的考验。",
  },
  {
    id: "m-007",
    title: "雾都疑云",
    type: "movie",
    year: 2023,
    region: "英国",
    genres: ["悬疑", "犯罪", "剧情"],
    rating: 8.0,
    popularity: 51470,
    duration: "121分钟",
    releaseDate: "2023-03-17",
    director: "艾米莉·哈特",
    status: "已上映",
    tagline: "迷雾散去之前，谁都不是清白的。",
    cast: [
      { personId: "p-06", role: "饰 侦探 格雷" },
      { personId: "p-09", role: "饰 记者 露西" },
    ],
    poster:
      "https://readdy.ai/api/search-image?query=Atmospheric%20british%20mystery%20thriller%20poster%2C%20foggy%20victorian%20london%20street%20with%20gaslights%2C%20a%20solitary%20silhouette%20under%20an%20umbrella%2C%20muted%20charcoal%20and%20teal%20tones%20with%20amber%20lamplight%2C%20moody%20cinematic%20composition%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=poster-m007&orientation=portrait",
    synopsis:
      "在终日浓雾笼罩的城市里，一名侦探受邀调查一起看似普通的失踪案。随着记者露西的介入，案件背后牵扯出的秘密越来越多，也牵扯出这座城市光鲜外表下的另一面。当真相浮出水面，没有人能够置身事外。",
  },
  {
    id: "m-008",
    title: "春日邮差",
    type: "movie",
    year: 2024,
    region: "日本",
    genres: ["剧情", "爱情", "治愈"],
    rating: 8.4,
    popularity: 58940,
    duration: "105分钟",
    releaseDate: "2024-03-22",
    director: "佐藤悠介",
    status: "已上映",
    tagline: "有些心意，需要有人替你送到。",
    cast: [
      { personId: "p-03", role: "饰 邮差 森田" },
      { personId: "p-07", role: "饰 花店店主 千夏" },
    ],
    poster:
      "https://readdy.ai/api/search-image?query=Gentle%20healing%20japanese%20drama%20movie%20poster%2C%20a%20young%20postman%20cycling%20through%20a%20cherry%20blossom%20lined%20country%20road%2C%20soft%20spring%20light%2C%20pale%20pink%20and%20fresh%20green%20tones%2C%20airy%20minimal%20composition%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=poster-m008&orientation=portrait",
    synopsis:
      "小镇邮差森田每天骑着自行车，把信件送到每一位居民手中。他渐渐发现，那些没有寄出地址的信里，藏着许多未曾传达的心意。在花店店主千夏的帮助下，他开始替人们完成这些迟到的告白。一个关于温柔与勇气的春日故事。",
  },
  {
    id: "t-001",
    title: "长夜将明",
    type: "tv",
    year: 2024,
    region: "中国大陆",
    genres: ["悬疑", "犯罪", "剧情"],
    rating: 8.8,
    popularity: 112680,
    duration: "共24集",
    releaseDate: "2024-02-08",
    director: "邓绍元",
    status: "全剧终",
    tagline: "黎明之前的每一秒，都值得被追问。",
    cast: [
      { personId: "p-01", role: "饰 检察官 裴远" },
      { personId: "p-09", role: "饰 记者 顾清晏" },
      { personId: "p-06", role: "饰 警探 秦朗" },
    ],
    poster:
      "https://readdy.ai/api/search-image?query=Tense%20chinese%20crime%20suspense%20series%20poster%2C%20a%20prosecutor%20silhouette%20against%20a%20city%20skyline%20just%20before%20dawn%2C%20deep%20navy%20and%20cold%20cyan%20tones%20with%20a%20thin%20amber%20light%2C%20premium%20streaming%20key%20art%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=poster-t001&orientation=portrait",
    synopsis:
      "年轻检察官裴远接手了一桩证据链看似完整的旧案，却在复查中发现诸多疑点。他与记者顾清晏、警探秦朗联手，一步步揭开被掩盖的真相。在漫长的深夜里，三个人各自背负着不同的代价，只为等来属于正义的那一缕晨光。",
  },
  {
    id: "t-002",
    title: "都市浮生记",
    type: "tv",
    year: 2023,
    region: "中国大陆",
    genres: ["都市", "剧情", "职场"],
    rating: 7.9,
    popularity: 83420,
    duration: "共36集",
    releaseDate: "2023-09-15",
    director: "林一鸣",
    status: "全剧终",
    tagline: "这座城市的灯火，为每个努力生活的人亮着。",
    cast: [
      { personId: "p-02", role: "饰 白领 苏念" },
      { personId: "p-08", role: "饰 创业者 江屿" },
      { personId: "p-10", role: "饰 房东 老周" },
    ],
    poster:
      "https://readdy.ai/api/search-image?query=Modern%20urban%20chinese%20drama%20series%20poster%2C%20young%20professional%20walking%20through%20a%20glowing%20office%20district%20at%20dusk%2C%20glass%20towers%20and%20warm%20window%20lights%2C%20muted%20navy%20and%20amber%20tones%2C%20contemporary%20key%20art%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=poster-t002&orientation=portrait",
    synopsis:
      "一群怀揣梦想的年轻人汇聚在繁华都市，在职场与生活的双重压力下各自寻找出路。有人为了理想坚持，有人向现实妥协，也有人在迷失后重新出发。剧集以群像视角，描绘当代都市人的真实浮生。",
  },
  {
    id: "t-003",
    title: "大明风云录",
    type: "tv",
    year: 2022,
    region: "中国大陆",
    genres: ["历史", "战争", "剧情"],
    rating: 8.5,
    popularity: 94760,
    duration: "共48集",
    releaseDate: "2022-10-01",
    director: "何远洲",
    status: "全剧终",
    tagline: "庙堂之高，江湖之远，皆系于一念之间。",
    cast: [
      { personId: "p-03", role: "饰 首辅 沈重" },
      { personId: "p-12", role: "饰 将军 陆骁" },
      { personId: "p-05", role: "饰 女官 云娘" },
    ],
    poster:
      "https://readdy.ai/api/search-image?query=Grand%20chinese%20historical%20epic%20drama%20poster%2C%20ancient%20palace%20hall%20with%20golden%20roofs%20and%20distant%20war%20banners%2C%20a%20minister%20in%20formal%20robe%20seen%20from%20behind%2C%20rich%20crimson%20and%20antique%20gold%20tones%2C%20majestic%20composition%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=poster-t003&orientation=portrait",
    synopsis:
      "王朝风雨飘摇之际，年轻首辅沈重受命于危难，力图整顿朝纲、抵御外患。朝堂之上暗流涌动，边关之外战火连连。他以一己之力周旋于权谋与家国之间，书写下一段波澜壮阔的历史风云。",
  },
  {
    id: "t-004",
    title: "我们的十年",
    type: "tv",
    year: 2024,
    region: "中国大陆",
    genres: ["青春", "爱情", "剧情"],
    rating: 8.2,
    popularity: 105340,
    duration: "共30集",
    releaseDate: "2024-04-12",
    director: "苏文青",
    status: "更新至22集",
    tagline: "青春是一群人，也是一段回不去的时光。",
    cast: [
      { personId: "p-02", role: "饰 林微" },
      { personId: "p-01", role: "饰 陈屿" },
      { personId: "p-07", role: "饰 苏念" },
    ],
    poster:
      "https://readdy.ai/api/search-image?query=Nostalgic%20youth%20chinese%20drama%20series%20poster%2C%20group%20of%20young%20friends%20on%20a%20school%20field%20at%20sunset%2C%20long%20shadows%20and%20warm%20lens%20flare%2C%20soft%20orange%20and%20mint%20tones%2C%20bittersweet%20cinematic%20composition%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=poster-t004&orientation=portrait",
    synopsis:
      "从校园到社会，一群好友在十年间经历了成长、离别与重逢。他们曾以为青春永不会结束，却在时光流逝中慢慢懂得珍惜。这是一个关于友谊、梦想与错过的故事，也是一代人共同的青春记忆。",
  },
  {
    id: "t-005",
    title: "深海迷航",
    type: "tv",
    year: 2023,
    region: "美国",
    genres: ["科幻", "悬疑", "惊悚"],
    rating: 8.6,
    popularity: 88710,
    duration: "共10集",
    releaseDate: "2023-06-20",
    director: "马克·道森",
    status: "全剧终",
    tagline: "海面之下，藏着比黑暗更深的东西。",
    cast: [
      { personId: "p-08", role: "饰 潜航员 凯恩" },
      { personId: "p-12", role: "饰 生物学家 艾拉" },
      { personId: "p-04", role: "饰 船长 老赵" },
    ],
    poster:
      "https://readdy.ai/api/search-image?query=Deep%20sea%20sci-fi%20suspense%20series%20poster%2C%20a%20lone%20submersible%20descending%20into%20pitch-black%20ocean%20toward%20a%20faint%20bioluminescent%20glow%2C%20deep%20navy%20and%20teal%20with%20cyan%20highlights%2C%20claustrophobic%20cinematic%20mood%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=poster-t005&orientation=portrait",
    synopsis:
      "一支深海科考队驾驶潜航器深入未知海沟，试图解开一段异常信号之谜。随着下潜深度增加，成员们接连遭遇无法解释的现象，彼此的信任也在幽闭环境中逐渐瓦解。海面之下的真相，远比他们预想的更加危险。",
  },
  {
    id: "t-006",
    title: "医者仁心",
    type: "tv",
    year: 2024,
    region: "中国大陆",
    genres: ["医疗", "都市", "剧情"],
    rating: 8.3,
    popularity: 79860,
    duration: "共40集",
    releaseDate: "2024-01-10",
    director: "林一鸣",
    status: "全剧终",
    tagline: "在生死之间，总有人选择坚守。",
    cast: [
      { personId: "p-09", role: "饰 外科主任 顾清晏" },
      { personId: "p-10", role: "饰 老院长 陈德" },
      { personId: "p-11", role: "饰 实习医生 小温" },
    ],
    poster:
      "https://readdy.ai/api/search-image?query=Emotional%20medical%20drama%20series%20poster%2C%20a%20surgeon%20in%20scrubs%20standing%20in%20a%20bright%20hospital%20corridor%20at%20dawn%2C%20clean%20white%20and%20soft%20teal%20tones%20with%20warm%20light%2C%20hopeful%20professional%20key%20art%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=poster-t006&orientation=portrait",
    synopsis:
      "在一家三甲医院的急诊科里，外科主任顾清晏带领团队日夜与死神赛跑。面对疑难病例、医患矛盾与自身的职业困境，他们始终守着最初的那份仁心。剧集以真实细腻的笔触，致敬每一位坚守岗位的医者。",
  },
  {
    id: "t-007",
    title: "首尔恋人",
    type: "tv",
    year: 2023,
    region: "韩国",
    genres: ["爱情", "剧情", "都市"],
    rating: 7.7,
    popularity: 68420,
    duration: "共16集",
    releaseDate: "2023-05-08",
    director: "金敏俊",
    status: "全剧终",
    tagline: "在这座城市的转角，爱情总会不期而遇。",
    cast: [
      { personId: "p-07", role: "饰 编辑 韩素拉" },
      { personId: "p-03", role: "饰 主厨 姜道贤" },
    ],
    poster:
      "https://readdy.ai/api/search-image?query=Romantic%20korean%20drama%20series%20poster%2C%20a%20couple%20under%20a%20starry%20seoul%20skyline%20on%20a%20rooftop%2C%20soft%20bokeh%20city%20lights%2C%20warm%20peach%20and%20twilight%20blue%20tones%2C%20tender%20cinematic%20composition%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=poster-t007&orientation=portrait",
    synopsis:
      "出版社编辑韩素拉与年轻主厨姜道贤因一次误会相识，从针锋相对到彼此扶持，两人在快节奏的都市里慢慢靠近。爱情、事业与家庭的抉择交织在一起，谱写成一首温暖的都市恋歌。",
  },
];